import { api } from '@/fsd/shared/api';
import {
  GetNotificationsListResponse,
  NotificationStatus,
} from '../../model/types/types';

interface IParams {
  status?: NotificationStatus;
  page?: number;
}

export const getNotificationsList = async ({
  status,
  page,
}: IParams): Promise<GetNotificationsListResponse | undefined> => {
  const params = new URLSearchParams({
    status: status ?? '',
    page: page ? String(page) : '1',
  });

  try {
    const data = await api.get<GetNotificationsListResponse>(
      '/api/v1/notification/list/?' + params.toString()
    );
    return data;
  } catch (e) {
    console.error('Ошибка при уведомлений:', e);
    return;
  }
};
